/**
 * Before / After comparison slider — accessible drag + keyboard control.
 * Works without JS: CSS renders a static 50/50 split via the --reveal fallback.
 */
(function () {
  const MIN = 0;
  const MAX = 100;
  const STEP = 5;

  class BeforeAfterSlider {
    constructor(root) {
      this.root = root;
      this.frame = root.querySelector('.before-after__frame');
      this.handle = root.querySelector('.before-after__handle');
      if (!this.frame || !this.handle) return;

      this.reveal = 50;
      this.pointerId = null;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.frame.addEventListener('pointerdown', this.onPointerDown);
      this.handle.addEventListener('keydown', this.onKeyDown);
    }

    setReveal(value) {
      this.reveal = Math.min(MAX, Math.max(MIN, value));
      this.root.style.setProperty('--reveal', this.reveal + '%');
      this.handle.setAttribute('aria-valuenow', String(Math.round(this.reveal)));
    }

    revealFromClientX(clientX) {
      const bounds = this.frame.getBoundingClientRect();
      if (bounds.width === 0) return;
      const ratio = (clientX - bounds.left) / bounds.width;
      this.setReveal(ratio * 100);
    }

    onPointerDown(event) {
      this.pointerId = event.pointerId;
      this.root.classList.add('is-dragging');
      try {
        this.frame.setPointerCapture(this.pointerId);
      } catch (error) {
        /* Pointer capture unsupported: dragging still works via move/up listeners. */
      }
      this.revealFromClientX(event.clientX);
      this.frame.addEventListener('pointermove', this.onPointerMove);
      this.frame.addEventListener('pointerup', this.onPointerUp);
      this.frame.addEventListener('pointercancel', this.onPointerUp);
      this.handle.focus();
    }

    onPointerMove(event) {
      if (event.pointerId !== this.pointerId) return;
      this.revealFromClientX(event.clientX);
    }

    onPointerUp(event) {
      if (event.pointerId !== this.pointerId) return;
      this.root.classList.remove('is-dragging');
      this.frame.removeEventListener('pointermove', this.onPointerMove);
      this.frame.removeEventListener('pointerup', this.onPointerUp);
      this.frame.removeEventListener('pointercancel', this.onPointerUp);
      this.pointerId = null;
    }

    onKeyDown(event) {
      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowDown':
          this.setReveal(this.reveal - STEP);
          event.preventDefault();
          break;
        case 'ArrowRight':
        case 'ArrowUp':
          this.setReveal(this.reveal + STEP);
          event.preventDefault();
          break;
        case 'Home':
          this.setReveal(MIN);
          event.preventDefault();
          break;
        case 'End':
          this.setReveal(MAX);
          event.preventDefault();
          break;
      }
    }
  }

  function initAll(root = document) {
    root.querySelectorAll('.before-after:not([data-initialized])').forEach((el) => {
      el.setAttribute('data-initialized', 'true');
      new BeforeAfterSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  }
})();
